import React from 'react';
import { Globals, Print, Constants } from 'utils';
import moment from 'moment';
import { CollectionService } from 'services';
import { Button, Input, DatePicker, Select } from 'components';

class ModalDownload extends React.Component {

	state = {
		form: {
			since: '',
			until: '',
			search: '',
			accredited: '',
			san: '',
			document: ''
		}
	}

	download = async () => {
		if (!this.state.form.since || !this.state.form.until) {
			Globals.showWarning("Por favor, seleccione dos fecha para filtrar en un rango de 366 días");
			return;
		}

		if (moment(this.state.form.until).diff(moment(this.state.form.since),'days') > 366) {
			Globals.showWarning("El rango máximo a exportar es de 366 días");
			return;
		}

		const res: any = await CollectionService.admin.download({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-download-collections">
				<div className="row row-filter">
					<div className="col-md-6">
						<Input
							value={ this.state.form.search }
							name="search"
							placeholder="Buscar"
							label="Nombre o correo"
							className="input-table"
							onChange={ (e: any) => {
								this.change(e); 
							} } />
					</div>
					<div className="col-md-6">
						<Input
							value={ this.state.form.document }
							name="document"
							placeholder="Buscar"
							label="Documento de Identidad"
							className="input-table"
							onChange={ (e: any) => {
								this.change(e); 
							} } />
					</div>
					<div className="col-md-6">
						<Select
							placeholder="Seleccionar"
							label="Acreditación"
							name="accredited"
							onChange={ (e: any) => this.change(e) }
							value={ this.state.form.accredited }
							options={ [
								{ value: Constants.ACCREDITED.YES.toString(), label: 'Acreditados' },
								{ value: Constants.ACCREDITED.NO.toString(), label: 'Sin Acreditar' },
							] } />
					</div>
					<div className="col-md-6">
						<Input
							value={ this.state.form.san }
							name="san"
							placeholder="Buscar"
							label="Nº de San"
							className="input-table"
							onChange={ (e: any) => {
								this.change(e); 
							} } />
					</div>
					<div className="col-md-6">
						<DatePicker
							showYearDropdown={ true }
							label="Desde (Inicio del San)"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'since'
									}
								});
							} }
							value={ this.state.form.since }
						/>
					</div>
					<div className="col-md-6">
						<DatePicker
							showYearDropdown={ true }
							label="Hasta (Inicio del San)"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'until'
									}
								});
							} }
							value={ this.state.form.until }
						/>
					</div>
				</div>

				<div id="modal-positions-excel">
	        		<div className="text-center">
						<Button type="submit" onClick={ () => this.download() }>
							Descargar
						</Button>
					</div>
	        	</div>
			</div>
		)
	}
}

export default ModalDownload;